import { Tooltip } from "antd";
import React from "react";
import { powerColor } from "../../redux/actions/utilAction";
import sx from "./Power.module.scss";

const Power = ({ count, isViewPost, powerWhite }) => {
  const powerScoreValue = count ? Math.round(count) : 50;
  const tooltipText = isViewPost
    ? "Gain more visits/likes/shares to increase your score."
    : "Add more posts and gain likes and shares to increase your score.";

  return (
    <Tooltip placement="bottomRight" title={tooltipText}>
      <div className={sx.root}>
        <span
          className={sx.title}
          style={{
            color: powerWhite ? "#fff" : "#647490",
          }}
        >
          {isViewPost ? "Power" : "Blog"} Score
        </span>

        <div
          style={{ backgroundColor: powerColor(powerScoreValue) }}
          className={sx.count}
        >
          {powerScoreValue}
        </div>
      </div>
    </Tooltip>
  );
};

export default Power;
